"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeColors = exports["default"] = void 0;
var _theme = _interopRequireDefault(require("../../theme"));
var _Colors = require("../../theme/Colors");
var _BorderRadiuses = require("../BorderRadiuses");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var breakpoints = ["".concat(_theme["default"].small + 1, "px"), "".concat(_theme["default"].medium + 1, "px"), "".concat(_theme["default"].large + 1, "px")];
breakpoints.small = breakpoints[0];
breakpoints.medium = breakpoints[1];
breakpoints.large = breakpoints[2];
// @ts-ignore
var space = [0, parseInt(_theme["default"].space05), parseInt(_theme["default"].space10), parseInt(_theme["default"].space15), parseInt(_theme["default"].space20), parseInt(_theme["default"].space30), parseInt(_theme["default"].space40), parseInt(_theme["default"].space50), parseInt(_theme["default"].space60), parseInt(_theme["default"].space80), parseInt(_theme["default"].space160)];
space.space160 = '128px';
space.space130 = '104px';
space.space100 = '80px';
space.space90 = '72px';
space.space80 = '64px';
space.space70 = '56px';
space.space60 = '48px';
space.space50 = '40px';
space.space40 = '32px';
space.space30 = '24px';
space.space20 = '16px';
space.space15 = '12px';
space.space10 = '8px';
space.space05 = '4px';
space.space025 = '2px';
space['-space160'] = '-128px';
space['-space130'] = '-104px';
space['-space100'] = '-80px';
space['-space90'] = '-72px';
space['-space80'] = '-64px';
space['-space70'] = '-56px';
space['-space60'] = '-48px';
space['-space50'] = '-40px';
space['-space40'] = '-32px';
space['-space30'] = '-24px';
space['-space20'] = '-16px';
space['-space15'] = '-12px';
space['-space10'] = '-8px';
space['-space05'] = '-4px';
space['-space025'] = '-2px';
var themeColors = exports.themeColors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _Colors.baseColors), _Colors.eligibilityColors), _Colors.scaleColors), _Colors.dataVisualisationColors), _Colors.alertColors), _Colors.legacyBackgroundColors), _Colors.legacyEligibilityColors), _Colors.backgroundColors), _Colors.formColors);
var totallyMoneyTheme = {
  breakpoints: breakpoints,
  space: space,
  colors: themeColors,
  radii: _BorderRadiuses.borderRadii
};
var _default = exports["default"] = totallyMoneyTheme;